<template>
  <svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
       width="48" height="48" :fill="color">
    <path
        d="M304.213333 232.96l-11.093333 7.68-58.453333-85.333333A35.84 35.84 0 0 0 170.666667 162.133333L8.106667 581.973333a35.84 35.84 0 0 0 3.413333 32.853334 35.84 35.84 0 0 0 29.44 15.36h450.986667a35.413333 35.413333 0 0 0 29.013333-55.466667l-59.306667-85.333333c146.773333-103.68 341.333333-85.333333 438.613334 42.666666a302.506667 302.506667 0 0 1 2.986666 344.746667 6.4 6.4 0 0 0 0 7.68 4.693333 4.693333 0 0 0 6.826667 0 452.693333 452.693333 0 0 0 40.106667-532.053333c-135.253333-210.773333-424.106667-263.253333-645.973334-119.466667z m0 0"
    ></path>
  </svg>
</template>
<script setup>
  defineProps({
    size: {
      type: [String, Number],
      default: 24
    },
    color: {
      type: String,
      default: 'currentColor'
    },
    viewBox: {
      type: String,
      default: '0 0 24 24'
    }
  })
</script>
<style scoped>

</style>